import React, { useState } from 'react';
import { Tabs, Tab, Container, ListGroup, Row, Col } from 'react-bootstrap';
import './ComplainComponent.css'; // Add this for custom styles

const ComplainComponent = ({title, complaints}) => {
  const [activeTab, setActiveTab] = useState('all');



  

 // Function to filter complaints based on the selected tab
const filterComplaints = () => {
  if (activeTab === 'all') {
    return complaints;
  }

  return complaints.filter((complain) => {
    if (activeTab === 'markAsDone') return complain.status === 'pending';
    if (activeTab === 'resolved') return complain.status === 'resolved';
    if (activeTab === 'rejected') return complain.status === 'rejected';
    return true;
  });
};


  return (
    <Container>
      <h3 className="my-4">{title}</h3>

      {/* Complaint Tabs */}
      <Tabs
        id="complain-tabs"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="complain-tabs mb-4"
      >
        <Tab eventKey="all" title="All" />
        <Tab eventKey="markAsDone" title="Mark as Done" />
        <Tab eventKey="resolved" title="Resolved" />
         <Tab eventKey="rejected" title="Rejected" />
      </Tabs>

      {/* Complaint List */}
      <ListGroup>
        {filterComplaints().map((complain, index) => (
          <ListGroup.Item key={complain.id}>
            <Row>
            <Col md={12}>
  <div className="complain-header">
    <h5>
    Complain # {index + 1}
      </h5>
      <span
                    className={`status ${
                      complain.status === 'resolved'
                        ? 'status-resolved'
                        : complain.status === 'rejected'
                        ? 'status-rejected'
                        : 'status-pending'
                    }`}
                  >
        {complain.status === 'resolved'
                      ? 'Resolved'
                      : complain.status === 'rejected'
                      ? 'Rejected'
                      : 'Pending'}
                  </span>
  </div>
  <div className="complain-text">
    <p>{complain.text}</p>
  </div>
  <div className="complain-footer">
    <p>{complain.user}</p>
    <p>{complain.date}</p>
  </div>
</Col>

            </Row>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Container>
  );
};

export default ComplainComponent;
